module.exports = __webpack_public_path__ + "static/media/typing.3593828a.svg";